/**
 * Returns the array sorted by the `order` property, either ascending or descending.
 * Use descending instead of sortByOrder(someArray).reverse(), since this will leave the order as is if there is no `order` prop
 */
export const sortByOrder = <T,>(
	items: T,
	{ descendingOrder } = { descendingOrder: false },
) => {
	if (!Array.isArray(items)) return items;

	return items.toSorted(
		(
			{ order: orderA }: { order?: number },
			{ order: orderB }: { order?: number },
		) => {
			if (orderA == null || orderB == null) return 0;

			return descendingOrder ? orderB - orderA : orderA - orderB;
		},
	) as T;
};
